<h2>🔗 Facebook Connection</h2>

<button (click)="connectFacebook()" [disabled]="loading">
  Connect Facebook
</button>

<p *ngIf="loading">Loading…</p>
<p *ngIf="error" style="color:red">{{ error }}</p>

<hr />

<!-- ================= USER TOKENS ================= -->

<div *ngIf="userToken" class="token-box">
  <h3>🔐 Short-Lived User Token</h3>
  <p>This token is returned by Facebook login and expires quickly.</p>
  <textarea rows="3" readonly style="width:100%">
{{ userToken }}
  </textarea>
</div>

<div *ngIf="longUserToken" class="token-box">
  <h3>♾️ Long-Lived User Token (~60 days)</h3>
  <p>This token is generated via backend exchange and used to fetch permanent page tokens.</p>
  <textarea rows="3" readonly style="width:100%">
{{ longUserToken }}
  </textarea>
</div>

<hr />

<!-- ================= PAGES ================= -->

<div *ngIf="pages.length">
  <h3>📄 Connected Pages ({{ pages.length }})</h3>

  <div *ngFor="let page of pages" class="page-card">

    <!-- PAGE INFO -->
    <h4>{{ page.name }}</h4>
    <p><strong>Page ID:</strong> {{ page.id }}</p>

    <!-- PERMISSIONS -->
    <p>
      <strong>Permissions:</strong>
      {{ page.tasks?.join(', ') || '—' }}
    </p>

    <p *ngIf="page.tasks?.includes('MANAGE')" style="color:green">
      ✔ Can Publish Content
    </p>

    <p *ngIf="!page.tasks?.includes('MANAGE')" style="color:#999">
      ✖ Read Only Access
    </p>

    <!-- TOKEN STATUS -->
    <p *ngIf="longUserToken" style="color:green">
      ✔ Using Long-Lived Authentication
    </p>

    <!-- PAGE TOKEN -->
    <h5>📄 Permanent Page Token</h5>
    <p>
      This token does not expire and is used for publishing posts.
    </p>

    <textarea rows="2" readonly style="width:100%">
{{ page.access_token || 'No page token available' }}
    </textarea>

    <hr />

    <!-- INSTAGRAM -->
    <h5>📸 Instagram Business Account</h5>

    <div *ngIf="page.loadingIg">
      <small>Checking Instagram connection…</small>
    </div>

    <div *ngIf="page.instagram_business_account">
      <p style="color:green">
        ✔ Connected
      </p>

      <p><strong>Instagram Business ID:</strong></p>

      <textarea rows="1" readonly style="width:100%">
{{ page.instagram_business_account }}
      </textarea>
    </div>

    <div *ngIf="page.instagram_business_account === null && !page.loadingIg">
      <p style="color:#999">
        ✖ No Instagram Business account connected
      </p>
    </div>

  </div>
</div>

<!-- ================= NO PAGES ================= -->

<div *ngIf="!loading && userToken && !pages.length">
  <p>No pages found for this user.</p>
</div>
